import { getPublicApiOrigin } from '../../config/env';

export { sendSingleInvite, sendBulkInvite } from '../../components/campaign/ExamTab';

/** Today's "Reset" for an in-progress session (PATCH /api/candidates/:id/reset-session). */
export async function resetCandidateSession(candidateId) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${getPublicApiOrigin()}/api/candidates/${candidateId}/reset-session`, {
    method: 'PATCH',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    throw new Error(typeof data.detail === 'string' ? data.detail : 'Failed to reset session.');
  }
  return data;
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
